(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["DecoupledDocumentEditor"] = factory();
	else
		root["DecoupledDocumentEditor"] = factory();
})(window, function() {
return 